import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';

export interface ConfirmOptions {
  title?: string;
  message: string;
  /** Confirm button label. Defaults to "Confirm". */
  confirmLabel?: string;
  /** Danger-styled confirm button (default true — most confirms guard
   *  a removal of some kind). */
  danger?: boolean;
}

/**
 * Simple styled confirmation modal — no typed phrase. Use for
 * recoverable actions (unassign, cancel invite, disable/reactivate,
 * transfer). For destructive deletes with real data loss (classes,
 * planners), use DeleteService (typed confirmation) instead.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private modalService = inject(NgbModal);

  async confirm(options: ConfirmOptions): Promise<boolean> {
    const m = await import('./confirm-modal.component');
    const modalRef = this.modalService.open(m.ConfirmModalComponent, { size: 'md' });
    modalRef.componentInstance.title = options.title ?? 'Are you sure?';
    modalRef.componentInstance.message = options.message;
    modalRef.componentInstance.confirmLabel = options.confirmLabel ?? 'Confirm';
    modalRef.componentInstance.danger = options.danger ?? true;

    try {
      const result = await firstValueFrom(modalRef.closed);
      return result === true;
    } catch {
      return false;
    }
  }
}
